// extracted by mini-css-extract-plugin
export var wrapper = "social-module--wrapper--X+FjF";
export var animated = "social-module--animated--hPIuE";
export var pulse = "social-module--pulse--UPoH1";
export var zoomIn = "social-module--zoomIn--br8qD";